import { TaskType, AnyObj } from './types';
import { qs } from '../request';
import { commonMarkName, perfMarkName, performanceKeyMap } from './constans';

export const getHash = (len: number = 6) => {
  return Math.random().toString(36).substr(2, len);
}

// mark name拼接
export const getMarkName = (type: TaskType, data: AnyObj, markDes?: string, uuid?: string, ) => {
  let markName = `${commonMarkName}-${type}`;
  if (type === 'error' || type === 'custom') { // error中有细分小的error类型 | custom 有具体的type标记类型
    markName += `-${data.type}`;
  }
  if (markDes) { // custom中模块自定义的mark描述信息
    markName += `-${markDes}`;
  }
  if (uuid) {
    markName += `-${uuid}`;
  }
  return markName;
}

// 获取 performance.entries中 性能相关的数据,只需要performanceKeyMap中相关字段的数据
export const getPerfEntries = (taskTimestamp: number, isInit?: boolean ) => {
  const entries = performance?.getEntries?.() || [];
  if (entries.length === 0) return [];

  let startIndex = entries?.findIndex?.((entry: any) => entry.entryType === 'mark' && entry.name === perfMarkName);
  if (startIndex === -1) {
    startIndex = 0;
  }
  const sliceEntries = entries?.slice?.(startIndex, entries.length) || [];
  let perfEntries: AnyObj[] = [];
  sliceEntries.length > 0 && sliceEntries.forEach((entry: AnyObj) => {
    // entry.encodedBodySize 不超过 1099511627776(1T) 过滤脏数据
    if (entry.entryType !== 'mark' && !(entry.encodedBodySize && entry.encodedBodySize >= 1099511627776)) {
      const newEntry: AnyObj = {};

      // 过滤掉perf中没有在提交字段中的字段
      for(let key in entry) {
        if (performanceKeyMap[key]) {
          newEntry[key] = entry[key];
        }
      }

      // 给api 增加traceId 和 具体的timestamp
      if (entry.entryType === 'resource' && entry.initiatorType === 'xmlhttprequest') {
        // name 截取掉后台拼接的ETEAMSID
        let name = entry.name.split('?ETEAMSID=')[0].split('&ETEAMSID=')[0];
        if (name.indexOf('weappmonitor_traceId') > -1) {
          const splitArr = name.split('?');
          const requestUrlparams = qs.parse(splitArr[1]);
          newEntry['traceId'] = requestUrlparams['weappmonitor_traceId'];
          newEntry['timestamp'] = parseInt(newEntry['startTime'] + taskTimestamp);
          delete requestUrlparams['weappmonitor_traceId'];

          // 去掉url地址中拼接的weappmonitor_tranceId
          if (Object.keys(requestUrlparams).length > 0) {
            newEntry['name'] = `${splitArr[0]}?${qs.stringify(requestUrlparams)}`;
          } else {
            newEntry['name'] = splitArr[0];
          }
        }
      }
      perfEntries.push(newEntry);
    }
  });

  // 第一次上报的时候,没有performance?.getEntriesByType?.('navigation')信息,通过performance.timing伪造下
  if (isInit && entries[0].entryType !== 'navigation') {
    let navigationData: AnyObj = {
      name: window?.location?.href,
      startTime: 0,
      workerStart: 0,
      type: 'navigate',
      entryType: 'navigation',
      initiatorType: 'navigation'
    };

    const timingData: AnyObj = performance.timing;
    if (typeof timingData === 'object') {
      for(let key in timingData) {
        if (performanceKeyMap[key]) {
          if (taskTimestamp && typeof timingData[key] === 'number' && timingData[key] >= taskTimestamp) {
            // 按照navagition的数据,将performance.timing的数据进行一次计算
            navigationData[key] = timingData[key] - taskTimestamp;
          } else {
            navigationData[key] = timingData[key];
          }
        }
      }
    }
    perfEntries.unshift(navigationData);
  }
  return perfEntries;
}

export const getMarkPointData = () => {
  const performance: any = window?.performance;
   // 记录当前渲染的dom节点数量
  let data: AnyObj = {
    nodeCount: document.querySelectorAll('*')?.length || 0,
  };
  // 记录内存参数
  if (typeof performance?.memory === 'object') {
    data = {
      ...data,
      jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
      totalJSHeapSize: performance.memory.totalJSHeapSize,
      usedJSHeapSize: performance.memory.usedJSHeapSize,
    }
  }
  return data;
}

// 按照后端的规则生成18位随机数字的uuid
export const getUuid = () => Math.round(Math.random() * 1000000000000000000).toString()

// 创建自定义事件监听
export const createCustomEvent = (type: string, detail: any) => {
  if (!!CustomEvent.prototype?.initCustomEvent) {
    const e = window.document.createEvent("CustomEvent");
    e?.initCustomEvent?.(type, true, true, detail);
    return e;
  }
  return new CustomEvent(type, { detail });
}